export default __webpack_public_path__ + "static/assets/fa162a721d967dde7c303824284e5694.png";